export default "/images/vendor/@coreui/icons/svg/flag/cif-dm.svg?afa72420e867a7392513882b83a97e2a";